import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../Routes/AuthContext";
import logo from "./../Assests/dyrect-logo.png";
import ShowIcon from './../Assests/shows.svg';
import CommunityIcon from './../Assests/community.svg';
import PaymentIcon from './../Assests/paymetHistory.svg';
import LogoutIcon from './../Assests/logout.svg';
import SettingsIcon from './../Assests/settings.svg';
import "./Sidebar.css";

const SideBar = ({ style, inMeeting }) => {
    const { logout } = useAuth();
    const [isExpanded, setIsExpanded] = useState(false);
    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();
    const isAdmin = localStorage.getItem('isAdmin') === 'true';

    const DEFAULT_APPLICATION = [
        {
            label: "Studio",
            path: "/shows",
            icon: ShowIcon
        },
        {
            label: "Community",
            path: "/community",
            icon: CommunityIcon
        },
        {
            label: "Payment History",
            path: "/payment",
            icon: PaymentIcon
        },
        ...(isAdmin ? [{
            label: "Admin",
            path: "/admin/payments-review",
            icon: SettingsIcon
        }] : [])
    ];

    const handleLogout = () => {
        localStorage.clear();
        logout();
    };

    const handleNavigate = (path) => {
        if (inMeeting) {
            window.open(path, '_blank');
        } else {
            navigate(path);
        }
    };

    const handleMouseEnter = () => {
        setIsExpanded(true);
    };

    const handleMouseLeave = () => {
        setIsExpanded(false);
    };

    const handleKeyDown = (event, callback) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            callback();
        }
    };

    return (
        <nav 
            className={`sidebar ${isExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={style}
            aria-label="Main navigation"
        >
            <div className="sidebar-inner">
                <div className="sidebar-main-content">
                    <div className="sidebar-header">
                        <div className="sidebar-logo-container">
                            <img src={logo} alt="Dyrect Logo" className="sidebar-logo-image" />
                            {isExpanded && (
                                <span className="sidebar-logo-text">yrect</span>
                            )}
                        </div>
                    </div>
                    
                    <div className="sidebar-content">
                        <div className="sidebar-menu">
                            {DEFAULT_APPLICATION.map((item, id) => {
                                const isActive = pathname === item.path || pathname.startsWith(item.path + '/');
                                return (
                                    <button
                                        key={id}
                                        type="button"
                                        className={`sidebar-menu-item ${isActive ? 'sidebar-menu-item-active' : ''}`}
                                        onClick={() => handleNavigate(item.path)}
                                        onKeyDown={(e) => handleKeyDown(e, () => handleNavigate(item.path))}
                                        aria-label={item.label}
                                        aria-current={isActive ? 'page' : undefined}
                                    >
                                        <img 
                                            src={item.icon} 
                                            alt="" 
                                            className={`sidebar-menu-icon ${item.label === 'Payment History' ? 'sidebar-payment-icon' : ''}`}
                                            aria-hidden="true"
                                        />
                                        {isExpanded && (
                                            <span className="sidebar-menu-label">{item.label}</span>
                                        )}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
                
                <div className="sidebar-footer">
                    <button 
                        type="button"
                        className="sidebar-menu-item sidebar-logout-item"
                        onClick={handleLogout}
                        onKeyDown={(e) => handleKeyDown(e, handleLogout)}
                        aria-label="Log out"
                    >
                        <img 
                            src={LogoutIcon} 
                            alt="" 
                            className="sidebar-menu-icon sidebar-logout-icon"
                            aria-hidden="true"
                        />
                        {isExpanded && (
                            <span className="sidebar-menu-label">Logout</span>
                        )}
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default SideBar;
